import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const LicenciaClaseE = props => <ServerComponentCaller url={"assets/data/pages/licencias/E.json"}/>;

export default LicenciaClaseE;
